module.exports = __webpack_public_path__ + "static/media/app01.038e8ee8.png";